export default __webpack_public_path__ + "static/media/circles.b6b9843c.svg";